module.exports = __webpack_public_path__ + "static/media/github-logo.d68ffe74.svg";